import React, {useState} from 'react';
import * as XLSX from 'xlsx';

const Upload = () => {
    const [data, setData] = useState([]); // Estado para almacenar los datos del archivo Excel
  
    // Función para manejar la carga del archivo Excel
    const handleFileUpload = (e) => {
      const file = e.target.files[0]; // Obtenemos el archivo cargado
  
      if (file) {
        const reader = new FileReader(); // Creamos un lector de archivos
        reader.onload = (event) => {
          const binaryString = event.target.result;
          const workbook = XLSX.read(binaryString, { type: 'binary' }); // Leemos el archivo Excel
  
          // Supongamos que queremos obtener los datos de la primera hoja del archivo
          const sheetName = workbook.SheetNames[0]; // Obtenemos el nombre de la primera hoja
          const worksheet = workbook.Sheets[sheetName]; // Obtenemos la hoja
  
          // Convertimos los datos de la hoja a formato JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // 'header: 1' para obtener los datos en un formato de array de arrays
  
          setData(jsonData); // Guardamos los datos en el estado
        };
        reader.readAsBinaryString(file); // Leemos el archivo como una cadena binaria
      }
    };
  
    return (
      <div>
        <h1>Subir archivo</h1>
        <input
          type="file"
          accept=".xlsx, .xls, .csv"
          onChange={handleFileUpload}
        />
        <div>
          <h3>Datos del archivo Excel:</h3>
          <table>
            <thead>
            <tr>
                    <th>N° Socio</th>
                    <th>RUT</th>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Tipo de Socio</th>
                    <th>Área</th>
                    <th>Teléfono</th>
                    <th>Correo</th>
                    <th>Dirección</th>
                    <th>Comuna</th>
                    <th>Ciudad</th>
                    <th>Fotografía</th>
                    <th>Observaciones</th>
                </tr>
            </thead>
            <tbody>
              {data.slice(1).map((row, index) => (
                <tr key={index}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  
  export default Upload;